module.exports = __webpack_public_path__ + "img/key.e3092533.svg";